























































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import TaskStatus from '@/components/tasks/TaskStatus.vue'
import TaskInfo from '@/components/tasks/TaskInfo.vue'
import TaskPhotos from '@/components/tasks/TaskPhotos.vue'
import TaskSurvey from '@/components/tasks/TaskSurvey.vue'
import TaskComments from '@/components/tasks/TaskComments.vue'
import TaskSignature from '@/components/tasks/TaskSignature.vue'
import TaskStatusButton from '@/components/tasks/TaskStatusButton.vue'
import {AppHeader, AppFooter} from '@/components/common'
import SignatureModal from '@/components/summary/SignatureModal.vue'
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue'
import SurveyModel from '@/classes/SurveyModel'
import {Task, Signature, Location} from '@/store/types'
import store from '@/store/store'
import DateFormatter from '@/classes/DateFormatter'
import { Route } from 'vue-router'
const auth = require('store')

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    AppHeader,
    AppFooter,
    TaskStatus,
    TaskInfo,
    TaskPhotos,
    TaskSurvey,
    TaskComments,
    TaskSignature,
    TaskStatusButton,
    SignatureModal,
    ConfirmationModal,
  },
})

export default class TaskHome extends Vue {
  @Getter('task') public task!: Task
  @Getter('showSignatureModal') public showSignatureModal!: boolean
  @Getter('showCompleteSurveyConfirmationModal') public showCompleteSurveyConfirmationModal!: boolean
  @Getter('showStartSurveyConfirmationModal') public showStartSurveyConfirmationModal!: boolean
  @Getter('location') public location!: Location
  @Getter('signature') public signature!: Signature
  @Mutation('setCompleteSurveyConfirmationModal') public setCompleteSurveyConfirmationModal!: any
  @Mutation('setStartSurveyConfirmationModal') public setStartSurveyConfirmationModal!: any
  @Mutation('setCompletedTask') public setCompletedTask!: any
  @Mutation('setFlashMessage') public setFlashMessage!: any
  @Mutation('setLoader') public setLoader!: any
  @Action('updateTask') public updateTask!: any
  public SurveyModel = SurveyModel

  public get getData() {
    const dateFormatter = new DateFormatter()

    if (this.task.status === SurveyModel.STATUS.ACTIVE) {
      return {
        status: SurveyModel.STATUS.IN_PROGRESS,
        started_at: dateFormatter.setServerTimezone().get(),
      }
    } else if (this.task.status === SurveyModel.STATUS.IN_PROGRESS) {
      return {
        status: SurveyModel.STATUS.COMPLETED,
        completed_at: dateFormatter.setServerTimezone().get(),
        signature: this.signature.image,
      }
    }
  }

  public startTask() {
    this.setStartSurveyConfirmationModal(false)
    this.setLoader(true)
    this.updateTask(Object.assign({lead_location_id: this.location.id}, this.task, this.getData))
        .then((task: Task) => {
          this.setLoader(false)
        }).catch((error: any) => {
      const payload = {
        flash: true,
        message: error.response.data.message,
        type: 2,
      }
      this.setLoader(false)
      this.setFlashMessage(payload)
    })
  }

  public completeTask() {
    this.setCompleteSurveyConfirmationModal(false)
    this.updateTask(Object.assign({lead_location_id: this.location.id}, this.task, this.getData))
    .then((task: Task) => {
      if (task.status === SurveyModel.STATUS.COMPLETED) {
        this.setCompletedTask(task)
        this.$router.push(`/`)
      }
    })
  }

  public back() {
    this.$router.back()
  }

  public reload() {
    window.location.reload()
  }

  public beforeRouteEnter(to: Route, from: Route, next: any)  {
    if (from.name === 'inbox') {
      store.commit('setLoader', true)
      store.dispatch('getTask', to.params.id)
          .then((task: Task) => {
            if (to.name === 'survey') {
              if (task.user_id !== auth.get('user').id) {
                const payload = {
                  flash: true,
                  message: 'Survey is no longer assigned to you, please refresh the app',
                  type: 2,
                }
                store.commit('setFlashMessage', payload)
                store.commit('setLoader', false)
                next('/')

              } else {
                store.commit('setLoader', false)
                next()
              }
            }
          })
    } else {
      next()
    }
  }

}
